import type { VideoMetadata } from '@/lib/video-metadata';

export type UploadPreviewCandidate =
  | { kind: 'video'; src: string; poster: string | undefined }
  | { kind: 'image'; src: string };

// What the upload modal tries to preview, in order. The modal moves to the next
// candidate when one fails to load and shows an info row once none is left.
// - Local files play from their blob URL (best_video_format).
// - Direct links ('http') play from the link itself: <video> needs no CORS.
// - YouTube metadata comes from the Data API, which returns no formats, so
//   YouTube shows its thumbnail.
// - Dropbox is previewed only after import.
export function uploadPreviewCandidates(
  metadata: VideoMetadata | null,
): UploadPreviewCandidate[] {
  if (!metadata || metadata.platform === 'dropbox') return [];

  const thumbnail = metadata.thumbnail || undefined;
  const videoSrc = metadata.best_video_format?.url
    || (metadata.platform === 'http' ? metadata.url : '');

  const candidates: UploadPreviewCandidate[] = [];
  if (videoSrc) candidates.push({ kind: 'video', src: videoSrc, poster: thumbnail });
  if (thumbnail) candidates.push({ kind: 'image', src: thumbnail });
  return candidates;
}
